import { useQuery } from '@tanstack/react-query';

import { WorkingHoursException } from 'src/features/workingHoursExceptions/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/site/:siteId/site-working-hours-exception/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    siteId: string;
    parkingId: string;
}
const queryFn = ({ siteId, parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<WorkingHoursException>> => {
    return axios.get(formatResourcePath(RESOURCE, { siteId, parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE],
        queryFn: async () => await queryFn(payload),
        staleTime: 1000 * 60 * 30,
        ...config,
    });

export { RESOURCE as LIST_WORKING_HOURS_EXCEPTIONS_RESOURCE, useQueryHook as useListWorkingHoursExceptions };
